import { render, staticRenderFns } from "./PointBuy.vue?vue&type=template&id=ef8708a6&lang=pug&"
import script from "./PointBuy.vue?vue&type=script&lang=js&"
export * from "./PointBuy.vue?vue&type=script&lang=js&"
import style0 from "./PointBuy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports